/** Shared Russian labels for enums shown in UI */

export const CATEGORY_LABELS: Record<string, string> = {
  soup: 'Суп',
  main_course: 'Основное блюдо',
  salad: 'Салат',
  dessert: 'Десерт',
  beverage: 'Напиток',
  snack: 'Закуска',
  breakfast: 'Завтрак',
  side_dish: 'Гарнир',
  bakery: 'Выпечка',
  other: 'Прочее'
};

export const ROLE_LABELS: Record<string, string> = {
  admin: 'Администратор',
  customer: 'Заказчик',
  customer_manager: 'Контролёр заказчика',
  supplier: 'Поставщик',
  employee: 'Сотрудник',
  support: 'Поддержка',
  delivery: 'Доставка'
};

export function categoryLabel(category?: string | null): string {
  if (!category) return '—';
  return CATEGORY_LABELS[category] || category;
}

export function roleLabel(role?: string | null): string {
  if (!role) return '—';
  return ROLE_LABELS[role] || role;
}
